import Actions from '../../odata/actions';

const actions = new Actions('brand', 'brands');

export default actions;
